import React, { useEffect, useState } from 'react';
import http from '../../services/http-service';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory, NavLink } from "react-router-dom";
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import './employee-list.css';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
// import FormGroup from '@mui/material/FormGroup';
import Button from '@mui/material/Button';
import Pagination from '@mui/material/Pagination';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from '@mui/icons-material/Edit';
// import { confirm } from 'react-confirm-box';
import debounce from 'lodash.debounce';



const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

function EmployeeList(props) {
    const history = useHistory();
    // history.go(0)
    const [count, setCount] = useState(0);
    const [open, setOpen] = useState(false);
    const [searchItem, setSearchItem] = useState('');
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(parseInt(props.match.params.page))
    const goToEmployeeDetails = (id) => () => {
        history.push('/user-details/' + id);
    }
    // const [dialogOpen, setDialogOpen] = useState(false);

    // const handleEmployeeStatus = (cellData) => {
    //     let postData = {
    //         id: cellData.profile.user,
    //         status: !cellData.is_active
    //     }

    //     handleToggle()
    //     http('admin/update_employee_status/', 'PATCH', postData)
    //         .then(res => {
    //             if (res.data.status) {
    //                 toast.success(res.data.message,{
    //                     toastId: "toastId25"
    //                   })
    //                 fetchEmployeeData(currentPage, searchItem)
    //             }
    //             else {
    //                 toast.error(res.data.message,{
    //                     toastId: "toastId24"
    //                   })
    //                 handleClose()
    //             }

    //         },
    //             err => {
    //                 handleClose()
    //                 console.log('err....', err)
    //             })
    // }
    useEffect(() => {
        fetchEmployeeData(currentPage, searchItem);
        // eslint-disable-next-line
    }, [props]);


    const handleSearch = debounce((value) => {
        setSearchItem(value)
        setCurrentPage(1)
        history.push('/employee-list/' + 1)
        fetchEmployeeData(1, value)
    }, 1000)

    const fetchEmployeeData = (value, search) => {

        if (value)
            setCurrentPage(parseInt(value))
        else
            setCurrentPage(1)
        // console.
        let params = {
            page: value,
            search: search
        }
        handleToggle()
        http('admin/employee/', 'GET', '', params)
            .then(res => {
                if (res.status) {
                    setCount(0)
                    setCount(Math.ceil(res.data.count / res.data.page_size))
                    setTableData(res.data.results)
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId23"
                      })
                }
                handleClose()
            },
                err => {
                    handleClose()
                    console.log('err....', err)
                })
    }

    const handlePageChange = (event, page) => {
        history.push('/employee-list/' + page);
        fetchEmployeeData(page, searchItem)
    }

    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    const addEmployee = () => {
        history.push("/add-employee");
    }

    // const viewEarning = (userId) => {
    //     history.push("/add-employee");
    // }


    // const confirmUser = async (data) => {
    //     const status = data.is_active ? 'Inactive' : 'Active'
    //     const message = 'Are you sure, you want to ' + status + ' this user?';
    //     const options = {
    //         title: "Confirm",
    //         labels: {
    //             confirmable: "Confirm",
    //             cancellable: "Cancel"
    //         },
    //         closeOnOverlayClick: true
    //     }
    //     const result = await confirm(message, options);
    //     if (result) {
    //         handleEmployeeStatus(data)
    //     }
    //     console.log("You click No!");
    // };

    return (
        <div className="mainAppDiv">
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}

            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <div className='employeeHeading_row'>
                <div className='employeeHeading'> Employee Management </div>
                <Grid item lg={4} className='upsearchGrid'>
                    <Search className='upseacrchDiv'>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase onChange={(e) => {

                            handleSearch(e.target.value)
                        }}
                            placeholder="Search…"
                            inputProps={{ 'aria-label': 'search' }}
                        />
                    </Search>
                </Grid>
                <Stack direction="row" spacing={2} className="justifyEnd">
                    <Button variant="contained" onClick={addEmployee}>Add Employee</Button>
                </Stack>
            </div>


            {
                tableData.length > 0 ?
                    <div>
                        <div className='customTable'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>User ID</th>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Email</th>
                                        <th>Phone Number</th>
                                        <th>Status</th>
                                        <th>Earning</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {tableData.map((data, index) => (
                                        <tr key={index}>
                                            <td key={'emp_id' + index}>{data.profile.emp_id}</td>
                                            <td key={'first_name' + index}>{data.first_name}</td>
                                            <td key={'last_name' + index}>{data.last_name}</td>
                                            <td key={'email' + index}>{data.email}</td>
                                            <td key={'phone_number' + index}>{data.phone_number}</td>
                                            <td key={'status' + index}>{data.profile.status}</td>
                                            <td key={'earning' + index}>{data.net_amount ? data.net_amount : ""}</td>
                                            <td><RemoveRedEyeIcon className='colorBlue cursorStyle' onClick={goToEmployeeDetails(data.id)} />
                                                <NavLink to={"/edit-employee/" + data.id} className="colorGreen ml-10 cursorStyle"><EditIcon></EditIcon></NavLink>
                                            </td>
                                        </tr>
                                    ))}


                                </tbody>
                            </table>
                        </div>

                        <Stack spacing={2} className="employeePagination">
                            <Pagination count={count} page={currentPage} color="primary" onChange={handlePageChange} />
                        </Stack>
                    </div> :
                    <div className='recordNotFoundDiv'>
                        <h2>Records Not Found</h2>
                    </div>
            }
        </div>
    )

}
export default EmployeeList;